import React from 'react';
import { i18n_start_your_free_membership_trial } from '@yi/i18n/phrases/i18n_start_your_free_membership_trial';
import { i18n_try_this_class_today_with_free_x_day_trial } from '@yi/i18n/phrases/i18n_try_this_class_today_with_free_x_day_trial';

import { TRIAL_DAYS } from '~/src/common/constants';

import { MultiViewPaywall } from './MultiViewPaywall';
import { InvalidMembership, AnonymousPaywall, FreeClassPaywall } from './paywallContent';
import { useLocale } from '../../LocaleProvider';

type Props = {
  onClose: () => void;
  returnUrl: string;
};
export const ClassPaywall: React.FC<Props> = ({ onClose, returnUrl }) => {
  const { locale } = useLocale();
  return (
    <MultiViewPaywall
      onClose={onClose}
      views={{
        Anon: setView => (
          <AnonymousPaywall
            heading={i18n_try_this_class_today_with_free_x_day_trial(locale, {
              days: String(TRIAL_DAYS),
            })}
            subHeading={i18n_start_your_free_membership_trial(locale)}
            onClickSignIn={() => setView('SignIn')}
            renderImage={() => null}
            returnUrl={returnUrl}
          />
        ),
        Free: () => <FreeClassPaywall returnUrl={returnUrl} />,
        InvalidMembership: () => <InvalidMembership />,
      }}
    />
  );
};
